// The member's standing (level) for the rank pill — derived by the home
// once it holds states + records, or loaded here when the pill mounts on a
// route the home has not booted on yet. One reactive object, one writer at
// a time; whoever knows first wins.
import { reactive } from 'vue';
import { learnedIds, learningIds, outcomeCounts, standingPoints, rankForPoints, phraseSet } from '@/services/engineLoop';

// `ids` are the learned expressions themselves (engineExpressions' own recIds,
// which are the library's recordId); `usedIds` the library uids already
// deployed in a completed record. 추천 표현 reads both: a phrase the member
// finished but has NEVER used is the one worth offering (2026-09-16).
export const standing = reactive({ known: false, learned: 0, ids: [], learningIds: [], usedIds: [], heard: 0, used: 0, points: 0, lv: 1, name: '스태프' });

export function setStanding({ states, records }) {
  const ids = learnedIds(states);
  const learned = ids.length;
  const { used, heard } = outcomeCounts(records);
  const usedIds = [...phraseSet(records, 'used')];
  const onIt = learningIds(states);
  const points = standingPoints({ learned, heard, used });
  const r = rankForPoints(points);
  Object.assign(standing, { known: true, learned, ids, learningIds: onIt, usedIds, heard, used, points, lv: r.lv, name: r.name });
  return standing;
}

let loading = null;
/** Fallback loader for surfaces that mount before the home (the top nav). */
export async function ensureStanding(uid, { stateService, deployService }) {
  if (standing.known || !uid) return standing;
  if (loading) return loading;
  loading = (async () => {
    try {
      const [all, records] = await Promise.all([
        stateService.fetchAll(uid).catch(() => ({ states: {} })),
        deployService.list(uid).catch(() => []),
      ]);
      if (!standing.known) setStanding({ states: (all && all.states) || {}, records: records || [] });
    } catch (e) { /* stays Lv.1 until the home derives it */ }
    loading = null;
    return standing;
  })();
  return loading;
}
